import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[960px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-secondary-700 bg-secondary-100 rounded-full mb-3">
            品牌故事
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">关于我们</h2>
        </div>

        <div className="bg-background-100 rounded-xl border border-background-200/60 p-6 md:p-8">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl mx-auto text-center mb-8">
            {aboutData.content}
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center p-4 rounded-lg bg-background-50">
                <div className="text-xl md:text-2xl font-black text-primary-500 mb-1">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}